export const PositiveTransactionEnum = [
  'DEPOSIT',
  'INTEREST_PAID',
  'REPAID_CAPITAL',
  'AUTOSELL_TRANSACTION',
  'CREDIT_LOSS_BUY_PRICE', //checkme
]
export const NegativeTransactionEnum = ['WITHDRAWAL']
export const InvestmentTransactionEnum = ['INVESTMENTS', 'CREDIT_LOSS_AMOUNT']
